import {BackBtn, BackBtnWhite} from '../../theme/icons';
import {StyleSheet, TouchableOpacity, View, Text, Image} from 'react-native';
import React, {useState} from 'react';
import images from '../../theme/images';

function HeaderCenter({props, isDisplay, type, isAfterInitial, title, config, headerStyle, hideThis}) {
    const [imgWidth, setImageWidth] = useState(0);
    const [imgHeight, setImageHeight] = useState(0);
    let size = 180;
    if(config){
        if(config.logo){
            size = Image.getSize(config.logo, (width, height) => {setImageWidth(width); setImageHeight(height);}, (error) => console.log(error));
        }
    }

    const outputType = () => {
        if((type == "logoOnly" && config.alignment == "middle" || type == "logoMidNavBoth")){
            if(imgWidth !== 0 && imgHeight !== 0){
                let ratio = 30 / imgHeight;
                size = (imgWidth * ratio);
                return (
                    config.useLogo ? (
                        <Image 
                            source={config.localImage ? config.localImage : config ? {uri: config.logo} : ""} 
                            style={{width: size, height: 30, resizeMode: "contain"}} 
                        />          
                        
                    ) : (
                        <Text style={{color: headerStyle.styles.topBarTextColor, fontSize: 20, fontWeight: "700"}}>{config.label}</Text>
                    )
                )
            } else {
                return (
                    <Text style={{color: headerStyle.styles.topBarTextColor, fontSize: 20, fontWeight: "700",}}>{config.label}</Text>
                ) 
            }
        } else {
            return (
                null
            )
        }
    }

    if(isAfterInitial){
        return(
           <Text style={{color: headerStyle.styles.topBarTextColor, fontSize: 20, fontWeight: "700"}}>{title}</Text>
        )
    } else {
        return(
            outputType()
        )
    }
   
}
export default HeaderCenter;